import React, { useEffect, useState } from "react";
import { Card, Button, Tag, Typography, Row, Col, Space, Divider, Avatar, Tabs, Modal, Spin, message, Input } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useLocation, useHistory } from "react-router-dom";
import {PlusOutlined,  SendOutlined, DeleteOutlined, ArrowRightOutlined, QuestionCircleOutlined, UserOutlined, EditOutlined, ArrowLeftOutlined, LeftOutlined } from "@ant-design/icons";

import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css"
import _consumerService from "../../../modules/consumerService";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../../constants/constants";
import { routes } from "../../../routes/Routes";
import StatusTag from "../../../components/StatusTag";
import _commonService from "../../../modules/commonService";

import CustomModal from '../../../components/Modal/Modal';
const { Text, Title, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;
const InfoRow = ({ label, value, highlight }) => (
  <div className="info-row">
    <Text className="label">{label}</Text>
    <Text className={`value ${highlight ? "highlight" : ""}`}>
      {value ? value : "N/A"}
    </Text>
  </div>
);

const ConsumerDetailApplicationOverview = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  //const isAllStepsCompleted = JSON.parse(localStorage.getItem("isAllStepsCompleted"));

  const [contactTeamModalVisible, setContactTeamModalVisible] = useState(false);
  const [contactMessageValue, setContactMessageValue] = useState('');
  const [contactMessageModalFlag, setContactMessageModalFlag] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [validationError, setValidationError] = useState('');

  let data = location.state;
  let applicationObjId = "";
  let applicationId = "";
  let applicationStatusId = null;
  let tabActiveKey = null;
  let emailId = '';

  if (data && data.email) {
    emailId = data.email;
  }

  if (data && data.activeKey) {
    tabActiveKey = data.activeKey;
  }

  if (data && data.applicationData && data.applicationData.Id) {
    applicationObjId = data.applicationData.Id;
  }

  if (data && data.applicationData && data.applicationData.ApplicationId) {
    applicationId = data.applicationData.ApplicationId;
  }

  if (data && data.applicationData && data.applicationData.Application_Status_Id) {
    applicationStatusId = data.applicationData.Application_Status_Id;
  }

  const [applnObjId] = useState(applicationObjId ? applicationObjId : localStorage.getItem("ApplicationObjId"));
  const [applnId] = useState(applicationId ? applicationId : localStorage.getItem("ApplicationIdText"));
  const [applnStatusId] = useState(applicationStatusId ? applicationStatusId : localStorage.getItem("ApplicationStatusId"));
  const [emailID] = useState(emailId ? emailId : localStorage.getItem("ApplicationEmailId"));
  const [applicantDetails, setApplicantDetails] = useState({});


  const applicationOverview = {
    applicationId: "App-10053",
    status: "Draft",
    submissionDate: "Not yet submitted",
    lastUpdated: "7th Jan 2026",
    requestedAmount: "$222,222.00",
    residency: "United States",
    useOfProceeds: "Liquidity for private asset financing",
    netWorth: "$22,000.00",
    cbrScore: "880",
    dti: "7.09%"
  };
  const deleteApplication = () => {
    confirm({
      title: "Are you sure, want to delete this Application?",
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteApplicationObj();
      }
    });
  };

  const deleteApplicationObj = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.deleteApplicationByAppId(applnObjId ? applnObjId : localStorage.getItem("ApplicationObjId"));
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        history.push({
          pathname: routes.consumerDashboard.path,
          state: { email: emailID },
        });
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const submitApplication = () => {
    const statusId = localStorage.getItem("ApplicationStatusId");
    const isResubmit = ["4", "5"].includes(statusId);

    let titleText = (localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)
      ? `The Balance Sheet Questionnaire is incomplete. Please review it before submitting. Would you like to review it now?`
      : `Are you sure, want to ${isResubmit ? "Resubmit" : "Submit"} this Application?`;

    confirm({
      title: titleText,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        if ((localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)) {
          history.push({
            pathname: routes.questionnaireForConsumer.path,
            state: { email: emailID, isFromDashboard: false },
          });
        } else {         
          submitApplicationObj();
        }

      }
    });
  };

  const submitApplicationObj = async () => {
    debugger
    if ((localStorage.getItem("IsQuestionairCompleted") == "false" || localStorage.getItem("IsQuestionairCompleted") == null)) {
      history.push({
        pathname: routes.questionnaireForConsumer.path,
        state: { email: emailID, isFromDashboard: false },
      });
    } else {
      setLoading(true);
      try {
        debugger
        const appObjId = localStorage.getItem("ApplicationObjId");
        const appObjectId = appObjId ? parseInt(appObjId) : null;

        const reqObj = {
          "Id": appObjectId,
          "Application_Status_Id": ["6"].includes(localStorage.getItem("ApplicationStatusId")) ? 11 : 2, // If status is Revision Requested or Action Required, set to Resubmitted (6), else set to Submitted
        }
        const res = await _consumerService.submitApplicationByAppId(reqObj);
        if (res.data.IsSuccess) {
          setLoading(false);
          message.success(res.data.Message ? res.data.Message : "Application submitted successfully!");
          localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
          localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
            history.push({pathname: routes.applicationSubmitted.path,});          
        } else {
          setLoading(false);         
          message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  };
  const editApplication = () =>{
    localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(false));
    localStorage.setItem("fromNewApplicationPage", JSON.stringify(false));
      history.push({
      pathname: routes.newLiquidityApplication.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isEditApplicationFromDetailPage: true, activeKey },
    });      
  }
   const getApplicantDetailsByID = async (applnObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getConsumerInformationByConsumerId(applnObjId);
      console.log(res, "res")
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
 useEffect(() => {  
      getApplicantDetailsByID(applnObjId);    
  }, []);

  const handleContactMessageChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setContactMessageValue(value);
      setCharCount(value.length);
      setValidationError('');
    } else {
      setValidationError('Message cannot exceed 500 characters');
    }
  };

  const handleSubmitContactMessage = () => {
    if (contactMessageValue.trim().length === 0) {
      setValidationError('Please enter a message');
      return;
    }
    if (contactMessageValue.length > 500) {
      setValidationError('Message cannot exceed 500 characters');
      return;
    }
    // Close the input modal and open success modal
    setContactMessageModalFlag(false);
    setContactTeamModalVisible(true);
    setContactMessageValue('');
    setCharCount(0);
    setValidationError('');
  };

  const handleCancelContactMessage = () => {
    setContactMessageModalFlag(false);
    setContactMessageValue('');
    setCharCount(0);
    setValidationError('');
  };
  const submitNewApplication = ()=>{
     history.push({
                pathname: routes.newLiquidityApplication.path,
                state: { fromNewApplicationPage: true, activeKey }
            });   
  }
  const handlerequestAppeal = async()=>{
     try {
        const appObjId = localStorage.getItem("ApplicationObjId");
        const appObjectId = appObjId ? parseInt(appObjId) : null;

        const reqObj = {
          "Id": appObjectId,
          "Application_Status_Id": 11, 
        }
        const res = await _consumerService.submitApplicationByAppId(reqObj);
        if (res.data.IsSuccess) {
          setLoading(false);
          message.success(res.data.Message ? res.data.Message : "Application submitted successfully!");
            history.push({
          pathname: routes.consumerDashboard.path
        });
          // localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
          // localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
          
        } else {
          setLoading(false);
          message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
  }
  return (
    <Card className="application-card cardViewMain ml5" bordered={false}>
      <Title level={4}>Application Overview</Title>

      <InfoRow label="Application ID" value={applicantDetails?.ApplicationId} />

      <div className="info-row">
        <Text className="label">Status</Text>
        <div className="StatusDivOverViewColumn">
         {/* <StatusTag statusId={applicantDetails?.Application_Status_Id} />           */}
         <StatusTag className="status-header" statusId={applicantDetails.Application_Status_Id === 5 ? 12 : applicantDetails.Application_Status_Id} />
        </div>
        {/* <Tag className="status-tag">applicantDetails?.Application_Status</Tag> */}
      </div>
       <div className="info-row">
        <Text className="label">Submission Date</Text>       
          <Text className="value">{ _commonService.getCurrentMonthAndYear(applicantDetails?.SubmissionDate)}</Text> 
       </div>   
        <div className="info-row">
        <Text className="label">Last Updated</Text>       
          <Text className="value">{ _commonService.getCurrentMonthAndYear(applicantDetails?.UpdatedDate)}</Text> 
       </div>            
      <div className="info-row">
        <Text className="label">Requested Loan Amount</Text>
        <Text className="value">
          {applicantDetails?.Cons_ApproximateLoanSize ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.Cons_ApproximateLoanSize)}` : "N/A"}          
          </Text> 
       </div> 
       
      <InfoRow label="Residency / Jurisdiction" value={applicantDetails.Cons_ConfirmResidency} />
      <InfoRow label="Use of Proceeds" value={applicantDetails.Cons_UseofProceeds} />

      <Divider />
<div className="info-row">
        <Text className="label">Net Worth</Text>
        <Text className="value">
          {applicantDetails?.CalNetworthTotal ? `$ ${_commonService.formatNumberWithCommas(applicantDetails.CalNetworthTotal)}` : "N/A"}          
          </Text> 
       </div> 
      <InfoRow label="CBR Score" value={applicantDetails.CBRScore} highlight />
      <div className="info-row">
        <Text className="label">Debt-to-Income Ratio</Text>
        <Text className="value">
          {applicantDetails.CalDebtIncomeRatio
            ? `${applicantDetails.CalDebtIncomeRatio}%`
            : "N/A"}
        </Text> 
       </div> 

      <div className="action-section">
        {/* <Button type="primary" block icon={<SendOutlined />}>
          Submit Application
        </Button> */}
   {!["2", "3", "4", "5", "7", "8", "9", "10", "11"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
            type="default"
            icon={<SendOutlined />}
            onClick={submitApplication}
          >
            {["6"].includes(localStorage.getItem("ApplicationStatusId")) ? "Resubmit Application" : "Submit Application"}
          </Button>
        }
        {!["2", "3", "4", "5", "7", "8", "9", "10", "11"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
            onClick={editApplication}
          block icon={<EditOutlined />}>
            Edit Application
          </Button>
        }
      
         {["10"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
          type="primary"
            onClick={submitNewApplication}
           icon={<PlusOutlined />}>
            Submit New Application
          </Button>
        }
        {["10"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
           className="requestAppealButton"
          block
            onClick={handlerequestAppeal}>
            Request Appeal
          </Button>
        }
    {["8"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
            type="default"            
          >
            Accept Offer
          </Button>
        }
         {["8"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
           className="requestAppealButton"
          block
            >
            View Offer Documents
          </Button>          
        }
          {["8"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
           className="requestAppealButton"
          block>
          Download Agreement
          </Button>          
        }



        {["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) &&
          <Button
            type="default"
            icon={<DeleteOutlined />}
            onClick={deleteApplication}
          >
            Delete Application
          </Button>
        }

       
      </div>

      <Divider />

      <Text className="help-text">Need help with your application?</Text>
      <Link className="Contactsupport-link" style={{ cursor: 'pointer' }} onClick={() => setContactMessageModalFlag(true)}>Contact support →</Link>

      <Divider />

      <Text className="disclaimer">
        ○ All applications are subject to credit assessment and approval.
        Submission does not guarantee approval.
      </Text>

        <CustomModal
          visible={contactMessageModalFlag}
          onClose={handleCancelContactMessage}
          onPrimaryAction={handleSubmitContactMessage}
          onSecondaryAction={handleCancelContactMessage}
          primaryButtonText="Submit"
          secondaryButtonText="Cancel"
          showSecondaryButton={true}
          title="Contact Support"
          description="Message:"
          showTextarea={true}
        >
          <TextArea
            value={contactMessageValue}
            onChange={handleContactMessageChange}
            placeholder="Enter your message here..."
            rows={4}
            maxLength={500}
            style={{ marginTop: 16, marginBottom: 8 }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text type={"secondary"} style={{ fontSize: 12 }}>
              {`${charCount}/500 characters`}
            </Text>
          </div>
          {validationError && (
            <div style={{ color: '#ff4d4f', marginTop: 4, fontSize: 12 }}>
              {validationError}
            </div>
          )}
        </CustomModal>

      <CustomModal
          visible={contactTeamModalVisible}
          onClose={() => setContactTeamModalVisible(false)}
          onPrimaryAction={() => {
              setContactTeamModalVisible(false);
          }}
          primaryButtonText="OK"
          showSecondaryButton={false}
          title="Thank you for your submission."
          description="A Levridge representative will be in contact with you within the next 24 hours."
      />
    </Card>
  );
};

export default ConsumerDetailApplicationOverview;
